export const routeConfig = {
  default: '/',
  login: '/login',
  logout: '/logout',
  dashboard: '/dashboard',
  notFound: '/404',
};
